import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import styles from '../styles.module.scss';

/////////////////////////////
// redux
import { useDispatch } from 'react-redux';
import {
  showMsgW as showMsgWAction,
  showMsgE as showMsgEAction,
  showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';

import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import VisibilityIcon from '@material-ui/icons/Visibility';

import TitlePage from '../../../components/TitlePage/TitlePage';

import Abas from '../../../components/Abas/Abas';
import TableHeader from '../../../components/Table/TableHeader';
import TablePagination from '../../../components/Table/TablePagination';
import {
  faleConoscoId,
  faleConoscoListagem,
  getAssuntoFaleConosco,
} from '../../../services/api-auto.js';
import services from '../../../services/index.js';
import { Button, MenuItem, Modal } from '@material-ui/core';
import Paginacao from '../../../components/Paginacao/index.jsx';
import { set } from '../../../services/storage.js';
import { celphone, cpf } from '../../../services/mask.js';

const FaleConosco = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const showMsgW = (msg) => dispatch(showMsgWAction(msg));
  const showMsgE = (msg) => dispatch(showMsgEAction(msg));
  const showMsgS = (msg) => dispatch(showMsgSAction(msg));
  const [abaActive, setAbaActive] = useState(1);
  const [faleDetalhe, setFaleDetalhe] = useState({});
  const [listaFaleConosco, setListaFaleConosco] = useState([]);
  const [paginacao, setPaginacao] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
    rows: 0,
  });
  const [busca, setBusca] = useState('');
  const [openModal, setOpenModal] = useState('');
  const [listaAssunto, setListaAssunto] = useState([]);

  const [form, setForm] = useState({
    email: '',
    assunto: '',
    telefone: '',
  });

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAnexoChange = (anexo) => {
    setForm((prevState) => ({
      ...prevState,
      anexo,
    }));
  };

  const fnGetAssuntoFaleConosco = () => {
    trackPromise(
      getAssuntoFaleConosco()
        .then((res) => {
          setListaAssunto(res.data.data);
        })
        .catch((error) => {
          showMsgE(error.errors.length ? error.errors[0].message : 'Error');
        })
    );
  };
  const fnFaleConoscoListagem = () => {
    trackPromise(
      faleConoscoListagem(
        paginacao.page,
        form.assunto,
        form.email,
        form.telefone
      )
        .then((res) => {
          setListaFaleConosco(res.data.data.items);
          setPaginacao({
            page: res.data.data.page,
            pageSize: res.data.data.pageSize,
            total: res.data.data.totalPages,
            rows: res.data.data.totalCount,
          });
        })
        .catch((error) => {
          showMsgE(error.errors.length ? error.errors[0].message : 'Error');
        })
    );
  };
  const fnFaleConoscoId = (id) => {
    trackPromise(
      faleConoscoId(id)
        .then((res) => {
          setFaleDetalhe(res.data.data.data);
        })
        .catch((error) => {
          showMsgE(error.errors.length ? error.errors[0].message : 'Error');
        })
    );
  };

  useEffect(() => {
    fnGetAssuntoFaleConosco();
  }, []);

  useEffect(() => {
    if (form.email === '' && form.assunto === '' && form.telefone === '') {
      fnFaleConoscoListagem();
    }
  }, [form.assunto, form.email, form.telefone]);

  useEffect(() => {
    fnFaleConoscoListagem();
  }, [paginacao.page]);

  return (
    <div className={`${styles.wrapper}`}>
      <div className={styles.title}>Fale Conosco</div>
      <div className="px-5 mt-3 mb-5">
        <div className="row">
          <div className="col-xs-12 col-md-3">
            <FormControl fullWidth>
              <TextField
                style={{ borderBottom: 'solid 1px #000' }}
                select
                label="Assunto"
                size="small"
                className="customFilledInput"
                name="assunto"
                value={form.assunto}
                onChange={handleFormChange}
              >
                <MenuItem value="">Selecione</MenuItem>
                {listaAssunto.map((item) => (
                  <MenuItem
                    key={item.faleConoscoAssuntoId}
                    value={item.descricao}
                  >
                    {item.descricao}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </div>
          <div className="col-xs-12 col-md-3">
            <FormControl fullWidth>
              <TextField
                label="E-mail"
                type="text"
                size="small"
                className="customFilledInput"
                name="email"
                value={form.email}
                onChange={handleFormChange}
              />
            </FormControl>
          </div>
          <div className="col-xs-12 col-md-2">
            <FormControl fullWidth>
              <TextField
                label="Telefone"
                type="text"
                size="small"
                className="customFilledInput"
                name="telefone"
                value={form.telefone}
                onChange={handleFormChange}
              />
            </FormControl>
          </div>

          <div className="col-xs-12 col-md-2">
            <FormControl fullWidth>
              <button
                style={{ height: 40, padding: 0, marginTop: 10 }}
                className="btnInvert "
                onClick={() => {
                  fnFaleConoscoListagem();
                  setPaginacao({ page: 1 });
                }}
              >
                Buscar
              </button>
            </FormControl>
          </div>
          <div className="col-xs-12 col-md-2">
            <FormControl fullWidth>
              <button
                style={{ height: 40, padding: 0, marginTop: 10 }}
                className="btnInvert "
                onClick={() => {
                  setForm({ assunto: '', email: '', telefone: '' });
                  setPaginacao({ page: 1 });
                }}
              >
                Limpar Filtro
              </button>
            </FormControl>
          </div>
        </div>
        <div
          style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}
        >
          <table
            className="table  table-bordered table-hover"
            style={{ width: '100%' }}
          >
            <thead>
              <tr>
                <th>Número do chamado</th>
                <th>Nome</th>
                <th>Email</th>
                <th>Telefone</th>
                <th>CPF</th>
                <th>Assunto</th>
                <th>Status</th>
                <th>Data de cadastro</th>
                <th>Data de abertura</th>
              </tr>
            </thead>
            <tbody>
              {listaFaleConosco.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => {
                    setOpenModal(item.faleConoscoId);
                    fnFaleConoscoId(item.faleConoscoId);
                  }}
                >
                  <td>{item.numeroChamado}</td>
                  <td>{item.nome}</td>
                  <td>{item.email}</td>
                  <td>{celphone(item.telefone)}</td>
                  <td>{cpf(item.cpf)}</td>
                  <td>{item.assunto}</td>
                  <td>{item.status}</td>
                  <td>
                    {item.dataCadastro
                      ? moment(item.dataCadastro).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>
                    {item.dataAbertura
                      ? moment(item.dataAbertura).format('DD/MM/YYYY')
                      : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          open={!!openModal}
          onClose={() => setOpenModal('')}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              backgroundColor: '#e0e0e0',
              padding: 30,
              width: '100%',
              maxWidth: '60%',
              maxHeight: '90%',
              overflow: 'auto',
              borderRadius: 15,
            }}
          >
            <div style={{ height: '100%' }}>
              <div
                style={{
                  border: '3px solid #5ccbe1',
                  padding: 10,
                  borderRadius: 15,
                  backgroundColor: '#ffffff',
                }}
              >
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <strong>Número do chamado:</strong>{' '}
                      {faleDetalhe ? faleDetalhe.protocolo : ''}
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <strong>Assunto:</strong>{' '}
                      {faleDetalhe ? faleDetalhe.assunto : ''}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <strong>Nome:</strong>{' '}
                      {faleDetalhe ? faleDetalhe.nome : ''}
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <strong>Status:</strong>{' '}
                      {faleDetalhe ? faleDetalhe.status : ''}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <strong>Email:</strong>{' '}
                      {faleDetalhe ? faleDetalhe.email : ''}
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <strong>Data de cadastro:</strong>{' '}
                      {faleDetalhe
                        ? moment(faleDetalhe.dataCadastro).format('DD/MM/YYYY')
                        : ''}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <strong>CPF:</strong> {faleDetalhe ? faleDetalhe.cpf : ''}
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <strong>Data de abertura:</strong>{' '}
                      {faleDetalhe
                        ? moment(faleDetalhe.dataAbertura).format('DD/MM/YYYY')
                        : ''}
                    </p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <strong>Anexo:</strong>{' '}
                      {faleDetalhe && faleDetalhe.anexo ? (
                        <a
                          href={
                            faleDetalhe.anexo.startsWith('https://')
                              ? faleDetalhe.anexo
                              : `https://${faleDetalhe.anexo}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Abrir anexo
                        </a>
                      ) : (
                        ''
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <br />
              <div
                style={{
                  border: '3px solid #5ccbe1',
                  padding: 10,
                  borderRadius: 15,
                  backgroundColor: '#ffffff',
                }}
              >
                <div className="row">
                  <div className="col-md-12">
                    <p>
                      <strong>Mensagem:</strong>{' '}
                      {faleDetalhe.mensagem ? faleDetalhe.mensagem : ''}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="row d-flex justify-content-center">
              <div className="col-md-4">
                <button
                  onClick={() => setOpenModal('')}
                  className="btnInvert w-100"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {paginacao.rows > 0 && (
          <Paginacao
            page={paginacao.page}
            setPage={(newPage) =>
              setPaginacao((prev) => ({
                ...prev,
                page: newPage,
              }))
            }
            maxPage={paginacao.total}
          />
        )}{' '}
      </div>
    </div>
  );
};

export default FaleConosco;
